import { Injectable } from '@angular/core';
import { DeliveryResponseDto } from 'src/generated_client';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private readonly KEY_TOKEN = 'token';
  private readonly KEY_REFRESH_TOKEN = 'refreshToken';
  private readonly KEY_DELIVERY_ID = 'cdDelivery';
  private readonly KEY_DELIVERY_PHONE = 'dsPhone';
  private readonly KEY_DELIVERY_NAME = 'dsName';
  private readonly KEY_LOGOUT_REASON = 'logoutReason';
  private readonly LEGACY_KEY_ACCESS_TOKEN = 'accessToken';

  constructor() { }

  setDeliveryUser(delivery: DeliveryResponseDto) {
    const resolvedToken = delivery?.token || delivery?.accessToken;

    this.setItem(this.KEY_DELIVERY_ID, delivery?.cdDelivery);
    this.setItem(this.KEY_DELIVERY_PHONE, delivery?.dsPhone);
    this.setItem(this.KEY_DELIVERY_NAME, delivery?.dsName);
    this.setItem(this.KEY_TOKEN, resolvedToken);
    this.setItem(this.KEY_REFRESH_TOKEN, delivery?.refreshToken);

    // Backward compatibility for older app versions that still read accessToken.
    this.setItem(this.LEGACY_KEY_ACCESS_TOKEN, resolvedToken);
  }

  getToken() {
    return localStorage.getItem(this.KEY_TOKEN) || localStorage.getItem(this.LEGACY_KEY_ACCESS_TOKEN);
  }

  getRefreshToken() {
    return localStorage.getItem(this.KEY_REFRESH_TOKEN);
  }

  getDeliveryId() {
    return localStorage.getItem(this.KEY_DELIVERY_ID);
  }

  getDeliverySession() {
    return {
      token: this.getToken(),
      refreshToken: this.getRefreshToken(),
      cdDelivery: this.getDeliveryId(),
      dsPhone: this.getItem(this.KEY_DELIVERY_PHONE),
      dsName: this.getItem(this.KEY_DELIVERY_NAME),
    };
  }

  clearDeliverySession() {
    this.removeItem(this.KEY_TOKEN);
    this.removeItem(this.KEY_REFRESH_TOKEN);
    this.removeItem(this.KEY_DELIVERY_ID);
    this.removeItem(this.KEY_DELIVERY_PHONE);
    this.removeItem(this.KEY_DELIVERY_NAME);
    this.removeItem(this.LEGACY_KEY_ACCESS_TOKEN);
  }

  setLogoutReason(value: string | null | undefined) {
    this.setItem(this.KEY_LOGOUT_REASON, value);
  }

  getLogoutReason() {
    return this.getItem(this.KEY_LOGOUT_REASON);
  }

  clearLogoutReason() {
    this.removeItem(this.KEY_LOGOUT_REASON);
  }

  getItem(key: string) {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string | null | undefined) {
    if (value === null || value === undefined || value === '') {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  // setItem(key: string, value: any) {
  //   if (!value || value == 'null') {
  //     localStorage.removeItem(key);
  //   } else {
  //     localStorage.setItem(key, value);
  //   }
  // }

  // getCartNo() {
  //   return localStorage.getItem('cart_no');
  // }

  // setCartNo(value: any) {
  //   this.setItem('cart_no', value);
  // }

  // clearCartNo() {
  //   localStorage.removeItem('cart_no');
  // }

  // getLid() {
  //   return localStorage.getItem('lid');
  // }

  // setLid(value: any) {
  //   this.setItem('lid', value);
  // }

  // getCartData() {
  //   return JSON.parse(localStorage.getItem('cart_data'));
  // }

  // setCartData(value: any) {
  //   this.setItem('cart_data', JSON.stringify(value));
  // }

  // clearCartData() {
  //   localStorage.removeItem('cart_data');
  // }

  // getRestaurantData() {
  //   return JSON.parse(localStorage.getItem('restaurant_data'));
  // }
  // setRestaurantData(value: any) {
  //   this.setItem('restaurant_data', JSON.stringify(value));
  // }
  // clearRestaurantData() {
  //   localStorage.removeItem('restaurant_data');
  // }

}